import { Extension } from 'tiptap'
import { selectAll } from 'prosemirror-commands'

export default class Clipboard extends Extension {

  get name() {
    return 'clipboard'
  }

  commands() {
    return {
      cut: () => this.cut(),
      copy: () => this.copy(),
      selectAll: () => selectAll
    }
  }

  cut() {
    return () => {
      document.execCommand('cut')
      return true
    }
  }

  copy() {
    return () => {
      document.execCommand('copy')
      return true
    }
  }
}